// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__CZ_6d","row":"Node_row__6B56H","label":"Node_label__6r9xC","footer":"Node_footer__16lUd"};